import connection from "../../utils/connection";

export const getLogin = async ({ user, password, captcha }) => {
  let response = {};

  const data = {
    "Usuario": user,
    "Clave": password,
    "captcha": captcha,
  }
  try {
    const responseGet = await connection({
      method: 'POST',
      url: '/login/login',
      body: data
    });

    response = responseGet;
  } catch (error) {
    console.error('catch service', error);
    response = error.response;
  }

  return response;
}
